module.exports = __webpack_public_path__ + "static/media/texMex.1b27e840.png";